import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import { Modal, notification } from 'antd';
import clone from 'lodash/clone';
import has from 'lodash/has';
import isEmpty from 'lodash/isEmpty';
import trim from 'lodash/trim';
import moment from 'moment';

import LogoName from 'components/Header/LogoName';
import { Field, Input, InputPassword, Label } from 'components/Input/Input';
import LangDropdown from 'components/common/Header/HeaderStrip/LangDropdown';

import { SettingsService } from 'services/SettingsService';
import { Storage } from 'services/Storage';

import { USER_DATA, USER_TOKEN_SET } from 'constants/ActionTypes';

import { store } from 'redux/store';

import { LOCAL_STORAGE_VAR, MASTER_NAME_LIST } from '../../constants/Common';
import { LOGIN_USER, RESEND_VERIFY_MAIL, UPDATE_USER_TOKEN } from '../../constants/apiConstant';
import { setLoader } from '../../redux/actions/Common';
import UtilService from '../../services/util';
import IntlMessages from '../../util/IntlMessages';
import Logo from '../Header/Logo';
import CheckBox from '../common/CheckBox';
import OpenNotification from '../common/CommonButton/OpenNotification';
import InputBlock from '../common/InputBlock';
import Loader from '../common/Loader';

import HiddenSvg from 'assets/svg/ChangePassword/hidden.svg';
import ShowSvg from 'assets/svg/ChangePassword/show.svg';

class LoginForm extends Component {
  constructor(props) {
    super(props);

    const rememberMe = Storage.get('r-up') ?? false;
    const user = rememberMe ? Storage.get('up') : null;

    this.state = {
      formData: { username: user?.username ?? '', password: user?.password ?? '' },
      rememberMe,
      error: null,
      verifyEmail: false,
      errors: {},
    };
  }

  componentDidMount() {
    const rememberMe = JSON.parse(localStorage.getItem(`${LOCAL_STORAGE_VAR}-rememberMe`));
    if (rememberMe) {
      const prevUser = localStorage.getItem(`${LOCAL_STORAGE_VAR}-remember-user`);
      if (prevUser && prevUser.length && prevUser !== 'undefined') {
        if (prevUser.indexOf('username') > 0) {
          localStorage.clear();
        } else {
          const user = UtilService.getLocalStorageItem(`remember-user`);

          const formData = {
            username: user.username,
            password: user.password,
          };
          this.setState({ formData, rememberMe });
        }
      }
    }
  }

  handleSubmit = () => {
    const reqObj = clone(this.state.formData);
    if (this.handleValidation()) {
      const obj = {
        ...LOGIN_USER,
        request: { ...reqObj, masters: MASTER_NAME_LIST },
      };

      UtilService.callApi(obj, (err, res) => {
        if (err) {
          if (err?.data?.code === 'E_BAD_REQUEST' && res?.data?.allowedTime) {
            const today = new Date().getTime();
            const dynamic = new Date(moment(err.data.data.allowedTime).format('')).getTime();
            const diff = (today - dynamic) / 1000 / 60;

            return OpenNotification({
              type: 'error',
              title: `Your account is blocked. Please, try again after ${
                Math.abs(Math.round(diff)) !== 0 ? Math.abs(Math.round(diff)) : 'a'
              }
                ${Math.abs(Math.round(diff)) !== 0 ? 'minutes.' : 'minute'}
                `,
            });
          } else {
            return OpenNotification({
              type: 'error',
              title: res?.message ?? res?.data?.message ?? 'Failed to Login.',
            });
          }
        }
        if (res && res.code === 'OK') {
          this.getRedirection(res);
        }
      });
    }
  };

  handleOnChange = (key, value) => {
    const { formData } = this.state;
    formData[key] = value;
    this.setState(formData);
  };

  handleVerifyEmail = () => {
    const self = this;
    const obj = {
      username: this.state.username,
    };
    const objData = {
      // method: "post",
      // url: api,
      ...RESEND_VERIFY_MAIL,
      request: obj,
    };

    UtilService.callApi(objData, async (err, data) => {
      if (err) throw err;
      if (data && data.code === 'OK') {
        self.setState({ verifyEmail: false });
      }
    });
  };

  handleUpdateToken = () => {
    const objData = {
      ...UPDATE_USER_TOKEN,
      request: { masters: MASTER_NAME_LIST },
      updateToken: this.state.updateToken, //token
    };
    UtilService.callApi(objData, (err, data) => {
      if (err) throw err;
      if (data && data.code === 'OK') {
        if (!has(data.data.user, ['isTermsCondAgree']) || !data.data.user.isTermsCondAgree) {
          this.setState({ showTCModal: true });
        } else {
          this.getRedirection(data);
        }
      }
    });
  };

  // handleAcceptTerms = () => {
  //   let self = this;
  //   let api = "/admin/user/update";
  //   let objData = {
  //     method: "put",
  //     url: api,
  //     request: { isTermsCondAgree: true },
  //     updateToken: self.state.updateToken,
  //   };
  //   UtilService.callApi(objData, async function (err, data) {
  //     if (err) throw err;
  //     if (data && data.code === "OK") {
  //       self.handleUpdateToken();
  //     }
  //   });
  // };
  getRedirection = (res) => {
    const user = res.data.user;

    const masters = res.data.masters;
    const columns = res.data.columns;
    const userPermissions = res.data.userPermissions;
    const keywords = res.data.keywords;
    const token = res.data.token.jwt;
    const terms = res.data.user.accountTerm;

    Storage.set(`token`, token);
    Storage.set(`user`, user);

    Storage.set(`master`, masters, false);
    Storage.set(`column`, columns, false);
    Storage.set(`keywords`, keywords, false);
    Storage.set(`isTrusted`, res.data.isTrusted, false);
    Storage.set(`terms`, terms);

    const setPermit = {};
    void userPermissions?.data?.forEach?.((x) => {
      if (x.module === 'order' && user.Setting) {
        x.permissions.insert = user.Setting.Is_PlaceOrder ? user.Setting.Is_PlaceOrder : false;
      }

      if (x.module === 'pricing' && user.Setting && user.Setting.Is_NoPrice !== true) {
        x.permissions.view = true;
        x.permissions.all = true;
      }
      setPermit[x.module] = x.permissions;
    });

    if (setPermit && !setPermit.pricing) {
      if (user.Setting && user.Setting.Is_NoPrice !== true) {
        setPermit.pricing = {};
        setPermit.pricing.view = !user.Setting.Is_NoPrice;
        setPermit.pricing.all = !user.Setting.Is_NoPrice;
      }
    }

    Storage.set(`userPermissions`, setPermit);
    Storage.set('r-up', this.state.rememberMe);

    Storage.delete('visited-fields');

    if (this.state.rememberMe) {
      Storage.set('up', { username: this.state.formData.username, password: this.state.formData.password });
    } else {
      Storage.delete('up');
    }

    SettingsService.setPermissions(setPermit);
    store.dispatch({ type: USER_TOKEN_SET, payload: token });
    store.dispatch({ type: USER_DATA, payload: user });

    if (window.location.href.split('=')[1]) {
      this.props.history.push(window.location.href.split('=')[1]);
    } else {
      this.props.history.push('/dashboard');
    }
  };

  handleValidation = () => {
    const formData = this.state.formData;
    const errors = this.state.errors;
    let formIsValid = true;
    const blankField = [];
    const invalidFiels = [];
    if (!formData['username'] || isEmpty(formData['username'])) {
      blankField.push('User Name');
      errors['username'] = true;
      formIsValid = false;
    }
    if (!formData['password'] || isEmpty(formData['password'])) {
      blankField.push('Password');
      errors['password'] = true;
      formIsValid = false;
    }

    if (blankField.length > 0) {
      const arr = blankField;
      let outStr = '';
      if (arr.length === 1) {
        outStr = arr[0];
      } else if (arr.length === 2) {
        outStr = arr.join(' and ');
      } else if (arr.length > 2) {
        outStr = arr.slice(0, -1).join(', ') + ' and ' + arr.slice(-1);
      }
      notification.error({
        message: 'Required Fields',
        placement: 'bottomLeft',
        description: outStr,
      });
    }
    if (invalidFiels.length > 0) {
      const arr = invalidFiels;
      let outStr = '';
      if (arr.length === 1) {
        outStr = arr[0];
      } else if (arr.length === 2) {
        outStr = arr.join(' and ');
      } else if (arr.length > 2) {
        outStr = arr.slice(0, -1).join(', ') + ' and ' + arr.slice(-1);
      }
      notification.error({
        message: 'Invalid Fields',
        placement: 'bottomLeft',
        description: outStr,
      });
    }
    this.setState({ errors: errors });
    return formIsValid;
  };

  render() {
    const { formData, errors } = this.state;

    return (
      <>
        <div className="loginDetail">
          <div className="loginHead">
            <div className="headerRightSide signIn">
              <div className="d-flex align-middle lang-color mr-10" align="middle">
                <LangDropdown />
              </div>
            </div>
            <div className="loginname">
              <LogoName />
            </div>
          </div>
          <div className="loginBox">
            {/* <Loader loading={this.state.loading} /> */}
            <Field hasError={Boolean(errors['username'])}>
              <Label>User Name</Label>
              <Input
                type="text"
                placeholder="User Name"
                value={formData.username}
                onChange={(e) => this.handleOnChange('username', trim(e.target.value))}
              />
            </Field>
            <Field hasError={Boolean(errors['password'])}>
              <Label>Password</Label>
              <InputPassword
                placeholder="Password"
                value={formData.password}
                onChange={(e) => this.handleOnChange('password', trim(e.target.value))}
                onKeyDown={(e) => {
                  e.keyCode === 13 && this.handleSubmit();
                }}
              />
            </Field>
            <div className="d-flex j-space-between align-items-center loginLinkBlock">
              <div className="rememberCheckBox">
                <CheckBox
                  id="remember-check"
                  checked={this.state.rememberMe}
                  value={this.state.rememberMe}
                  onChange={(e) => this.setState({ rememberMe: e.target.checked })}
                />
                <span className="rememberLabel">
                  <IntlMessages id="app.signIn.RememberMe" />
                </span>
              </div>
              <Link to="/forgot-password" className="primary-text forgot-password">
                <IntlMessages id="app.signin.forgotPassword" />
              </Link>
            </div>
            <div className="loginButton">
              <button className="commonButton login-button" onClick={() => this.handleSubmit()}>
                <IntlMessages id="app.signUp.LogIn" />
              </button>
              <div className="registerLogLink">
                <IntlMessages id="app.signin.dontHaveLogin" />
                <Link to="/signup">
                  <IntlMessages id="app.signup.registerButton" />
                </Link>
              </div>
              {/* <button
                onClick={() => {
                  this.props.history.push("/guest-login");
                }}
                className="commonOutline"
              >
                Guest Login
              </button> */}
            </div>

            {/* <hr style={{ marginBottom: "10px", marginTop: "10px" }} className="login-shapret" /> */}

            {/* </form> */}
            {this.state.verifyEmail && (
              <button className="commonButton" id={'verifyEmailBtn'} onClick={this.handleVerifyEmail}>
                Verify Email
              </button>
            )}
          </div>
        </div>
        <Modal
          visible={this.state.showModal}
          title={[
            <h2 key="deletebuttonH2" className="modal__title primary-text" id="modal-1-title">
              Confirmation
            </h2>,
          ]}
          onCancel={() => this.setState({ showModal: false })}
          footer={[
            <div key="deletebuttonReminder">
              <button
                className="modal__btn button primary-fill"
                style={{ padding: '9px 25px' }}
                onClick={this.handleUpdateToken}
              >
                Yes
              </button>
              <button
                className="button button-outline primary-outline"
                style={{ padding: '9px 25px' }}
                onClick={() => this.setState({ showModal: false })}
              >
                No
              </button>
            </div>,
          ]}
          width={620}
        >
          <h3 align="center" style={{ color: 'rgba(0,0,0,0.70)' }}>
            It appears that, you are already Logged-In on other Device. Do you wish to Continue here and logout from
            earlier device?
          </h3>
        </Modal>
      </>
    );
  }
}

const mapStateToProps = ({ common }) => {
  const { loading } = common;
  return { loading };
};

export default withRouter(connect(mapStateToProps, { setLoader })(LoginForm));
